module.exports = __webpack_public_path__ + "static/media/24.43d70ed9.mp3";